import axios from '@/axios';

const CounselorApi = {
  /**
   * 상담톡 신청 목록 조회
   * @param {Object} params - 검색 파라미터
   * @param {number} params.page - 페이지 번호
   * @param {number} params.limit - 페이지당 항목 수
   * @param {string} [params.keyword] - 검색 키워드
   * @param {string} [params.status] - 상태 필터
   * @returns {Promise} 응답에 kakaoChannels 배열 포함
   */
  getList(params) {
    return axios.post('/companies/counselor-admin/list', params);
  },

  /**
   * 상담톡 상세 조회
   * @param {string} companyId - 회사 ID
   * @param {string} channelId - 채널 ID (필수)
   * @returns {Promise} 응답에 해당 채널의 상세 정보 포함
   */
  getDetail(companyId, channelId) {
    return axios.get(`/companies/counselor-admin/${companyId}?channelId=${encodeURIComponent(channelId)}`);
  },

  /**
   * 상담톡 상태 및 발신프로필키 수정
   * @param {string} companyId - 회사 ID
   * @param {Object} data - 수정 데이터
   * @param {string} data.channelId - 채널 ID (필수)
   * @param {string} [data.senderKey] - 발신프로필키
   * @param {string} [data.receiveUrl] - 상담톡 수신 URL
   * @param {boolean} [data.syncDkt] - DKT 상담톡 API 동기화 여부
   * @param {string} [data.status] - 상태 (pending, connected, disconnecting, disconnected)
   * @returns {Promise}
   */
  update(companyId, data) {
    return axios.put(`/companies/counselor-admin/${companyId}`, data);
  },

  /**
   * 관리자 삭제
   * @param {string} companyId - 회사 ID
   * @param {string} channelId - 채널 ID
   * @param {string} phone - 관리자 전화번호
   * @returns {Promise}
   */
  deleteAdmin(companyId, channelId, phone) {
    return axios.delete(`/companies/counselor-admin/${companyId}/channels/${encodeURIComponent(channelId)}/admins/${phone}`);
  },
};

export default CounselorApi;
